import { RouteProps } from 'react-router-dom';
import { demoPagesMenu, landingPagesMenu, pageLayoutTypesPagesMenu } from '../menu';

const footers: RouteProps[] = [
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.signUp.path, element: null },
	{ path: demoPagesMenu.page404.path, element: null },
	{ path: landingPagesMenu.home.path, element: null },
	{ path: landingPagesMenu.policy.path, element: null },
	{ path: '*', element: null },
];

export default footers;
